import Countdown from 'antd/es/statistic/Countdown';
import { withConfigProvider } from '../config-provider';
export default withConfigProvider(Countdown);
